<!-- Wrapper for main nav including toggle for mobile devices -->
<template>
  <div class="app-menu-wrapper">
    <cat-btn class="app-menu-btn" icon="menu" @ui-click="toggleMenu">{{
      resolveTxt("skin.mainnav.open", "Show menu")
    }}</cat-btn>

    <nav :aria-label="resolveTxt('skin.mainnav.label', 'Main navigation')">
      <div :class="_containerCss">
        <cat-menu-items
          :depth="parseInt(depth)"
          :items="items"
          :is-root="isRoot"
        ></cat-menu-items>
      </div>
    </nav>

    <Teleport to="#layout-body-end">
      <div v-if="toggleMenuDelay" class="app-menu-mobile">
        <cat-btn
          class="app-menu-close main-nav-hide hide-for-medium small"
          icon="times-light"
          @ui-click="toggleMenu"
        >
          {{ resolveTxt("skin.mainnav.close", "Close menu") }}
        </cat-btn>
        <nav :aria-label="resolveTxt('skin.mainnav.label', 'Main navigation')">
          <div :class="_containerCss">
            <cat-menu-items
              :depth="parseInt(depth)"
              :items="items"
              :is-root="isRoot"
            ></cat-menu-items>
          </div>
        </nav>
        <div class="app-menu-bg" @click="toggleMenu"></div>
      </div>
    </Teleport>
  </div>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import catBtn from "@/components/catBtn/catBtn";
import catMenuItems from "@/components/catMenuItems/catMenuItems";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", (key, def, warn) => def);

    return {
      resolveTxt
    };
  },
  name: "CatAppMenu",
  components: { catMenuItems, catBtn },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
      description:
        "Array of objects defining the menu structure. Objects can have following properties: 'cap' - Menu item label (string); 'id' - unique menu item ID (string); 'href' - item's href attribute value (string); 'target' - browser target - e.g. '_blank' (string); 'css' - css classes for the item (array of strings); 'group' - child items (array of objects) "
    },
    depth: {
      type: [Number, String],
      default: 0,
      description: "0 or 1 - affects the css classes (and styling)"
    },
    isRoot: {
      type: Boolean,
      default: false,
      description:
        "Indication of the root level - most of the times you want this to be true unless nesting in other navigations"
    }
  },
  data: function () {
    return {
      toggleFlag: false,
      toggleMenuDelay: this.toggleFlag
    };
  },
  computed: {
    _containerCss: function () {
      return {
        "cat-app-menu": true
      };
    }
  },
  methods: {
    toggleMenu: function () {
      const _this = this;
      const body = document.querySelector("body");
      const content = document.querySelector(".app-content");

      this.toggleFlag = !this.toggleFlag;

      // Body class for overflow hidden
      // Adds aria-hidden true to content for Accessibility
      if (this.toggleFlag) {
        body.classList.add("modal-open");
        content.setAttribute("aria-hidden", true);
        this.toggleMenuDelay = this.toggleFlag;

        //Adding delay before focusing to close btn
        setTimeout(function () {
          document.querySelector(".app-menu-close").focus();
          document.querySelector(".app-menu-mobile").classList.add("active");
        }, 50);
      } else {
        body.classList.remove("modal-open");
        content.removeAttribute("aria-hidden");
        document.querySelector(".app-menu-mobile").classList.remove("active");

        //Delay to let menu close before removing content
        setTimeout(function () {
          document.querySelector(".app-menu-btn").focus();

          _this.toggleMenuDelay = _this.toggleFlag;
        }, 400);
      }
    }
  }
});
</script>
